import { Injectable } from '@angular/core';
import {
  RoutingService
} from '@spartacus/core';
import { Observable, Subject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { UigContentSearchAdapter } from './uig-content-search.adapter';
import { ContentSearchData } from './uig-content-search.models';

@Injectable({
  providedIn: 'root',
})
export class UigContentSearchService {

  private currentSearch : string;
  private result$ = new Subject<ContentSearchData>();
  private loading$ = new Subject<boolean>();

  constructor(
    private routing: RoutingService,
    private uigContentSearchAdapter: UigContentSearchAdapter
  ) {
    this.loading$.next(false);
  }

  /**
   * Navigates to the content search result page with a given query
   */
  launchSearchPage(query: string): void {
    this.routing.go(
      {
        cxRoute: 'contentSearch',
        params: { query },
      }
    );
  }

  contentSearch(search: string) : void {
    if(search === this.currentSearch) {
      return;
    }
    this.loading$.next(true);
    this.currentSearch = search;
     this.uigContentSearchAdapter
      .contentSearch(search).pipe(
        filter((response) => response != null),
        tap((response) => {
          // console.log(JSON.stringify(response));
          this.result$.next(response);
          this.loading$.next(false);
        })
      ).subscribe();
  }

  getLoading() : Subject<boolean> {
    return this.loading$;
  } 

  getResult() : Subject<ContentSearchData> {
    return this.result$;
  }

}
